// The skin contract, kept name-compatible with the hub's skin-core `SkinMeta` (hub ADR-0011) so this
// folder can be swapped for a packages/skin-<brand> alias when Scout ships as a pack. Skins differ
// in VALUES and assets, never in token names.
export interface SkinMeta {
  productName: string
  tagline: string
  busyLabel: string
}

export const meta: SkinMeta = {
  productName: 'Scout',
  tagline: 'The warm path to the next engagement',
  busyLabel: 'Working…',
}
